import { useEffect, useState } from 'react';
// import TableBody from '@mui/material/TableBody';
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
import FadeIn from 'react-fade-in/lib/FadeIn';
import LoadingComponent from '../../../../lib/LoadingComponent';
import { Card, Input, Button, Table, Empty, Popconfirm } from 'antd';
import ListIcon from '@mui/icons-material/List';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import { getBizID } from '../../../../libs/todoSlice';
// import TableFooter from '@mui/material/TableFooter';
// import TablePagination from '@mui/material/TablePagination';
// import { useTheme } from '@mui/material/styles';
// import PropTypes from 'prop-types';
// import Box from '@mui/material/Box';
// import IconButton from '@mui/material/IconButton';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import { styled } from '@mui/material/styles';
import { Row, Col } from 'react-bootstrap';
import { Chip, Stack } from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Swal from 'sweetalert2';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import Edit from '@mui/icons-material/Edit';



const MophCaregiverTable = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [countEmployees, setCountEmployees] = useState(0)
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [cookie] = useCookies(['account', 'new_user'])
    const business_id = useSelector(getBizID)
    const [searchtext, setSearchText] = useState('')
    const [defaultdata, setDefaultData] = useState([])
    const [new_user_count, setNew_User_Count] = useState(0)
    const [new_user, setNew_User] = useState()
    const [total, setTotal] = useState()
    const [onlyNewData, setOnlyNewData] = useState(false)
    const [resulttotal, setResultTotal] = useState(0)

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };

    const getData = async () => {
        try {
            const { data, status } = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v6/businesses/${business_id}/moph-caregiver-pre-register/pre-registers`,
                params: {
                    page: page,
                    perPage: pageSize,
                    search: searchtext,
                    onlyNewData: onlyNewData
                }
            })
            setTotal(data.data.total)
            let prepare_data = data.data.result.filter(i => i.status === 'active').map((item, index) => {
                return {
                    index: index + 1,
                    kind: item.kind,
                    _id: item._id,
                    createdAt: item.createdAt,
                    address: item.other.address,
                    sub_district: item.other.sub_district,
                    district: item.other.district,
                    province: item.other.province,
                    zipcode: item.other.zipcode,
                    idCardType: item.idCardType,
                    idCardNum: item.idCardNum,
                    mobileNO: item.mobileNO,
                    employeeID: item.employeeID,
                    name_th: (item.specialTitleTH ? item.specialTitleTH : item.accountTitleTH ? item.accountTitleTH : '') + " " +
                        (item.firstNameTH ? item.firstNameTH : '') + " " +
                        (item.other.middle_name_th ? item.other.middle_name_th : '') + " " +
                        (item.lastNameTH ? item.lastNameTH : ''),
                    name_eng: (item.specialTitleENG ? item.specialTitleENG : item.accountTitleENG ? item.accountTitleENG : '') + " " +
                        (item.firstNameENG ? item.firstNameENG : '') + " " +
                        (item.other.middle_name_eng ? item.other.middle_name_eng : '') + " " +
                        (item.lastNameENG ? item.lastNameENG : ''),
                    active: item.status
                }
            })
            setCountEmployees(data.data.total)
            setResultTotal(data.data.resultTotal)
            function isDateBefore24Hours(dateString) {
                const currentDate = new Date();
                const givenDate = new Date(dateString);
                const twentyFourHoursAgo = new Date();
                twentyFourHoursAgo.setHours(currentDate.getHours() - 24);
                return givenDate > twentyFourHoursAgo;
            }
            let newData = prepare_data.filter(item => isDateBefore24Hours(item.createdAt))
            setNew_User(newData)
            setNew_User_Count(data.data.newData)
            setData(prepare_data)
            setDefaultData(prepare_data)
        }
        catch (err) {
        }
        setLoading(false)
    }

    useEffect(() => {
        
        getData()
    }, [page, pageSize, onlyNewData])

    useEffect(() => {
        setSearchText('')
        setOnlyNewData(false)
        setLoading(true)
    }, [])



    const columns = [
        {
            title: 'ลำดับ',
            width: 70,
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, __, index) => {
                return (
                    <>{((page * pageSize) - pageSize) + index + 1}</>
                )
            }
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาไทย)
                </div>
            ),
            dataIndex: 'name_th',
            key: 'name_th',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาอังกฤษ)
                </div>
            ),
            dataIndex: 'name_eng',
            key: 'name_eng',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'idCardType',
            key: 'idCardType',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }

            }
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'เลขบัตรประชาชน',
            dataIndex: 'idCardNum',
            key: 'idCardNum',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === 'WAITING') {
                    return <LoadingComponent width={50} height={50} />
                }
                else if (_ !== 'DUMMY') {
                    return (
                        <>{_}</>
                    )
                }
                else {
                    return (
                        <>ไม่มีข้อมูล</>
                    )
                }
            }
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'รหัสพนักงาน',
            dataIndex: 'employeeID',
            key: 'employeeID',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }

            }
        },
        {
            title: 'เบอร์โทร',
            dataIndex: 'mobileNO',
            key: 'mobileNO',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (tel, record, index) => {
                if (tel === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else if (!record.editTel) {
                    return (
                        <>
                            {tel} {
                                <IconButton
                                    aria-label="edit"
                                    size="small"
                                    onClick={() => {
                                        setData(prevData => {
                                            const newData = [...prevData];
                                            newData[record.index - 1] = { ...newData[record.index - 1], editTel: true };
                                            return newData;
                                        });
                                    }}
                                >
                                    <Edit fontSize="inherit" />
                                </IconButton >
                            }
                        </>
                    )
                } else if (record.editTel) {
                    const save = async () => {
                        try {
                            setData(prevData => {
                                const newData = [...prevData];
                                newData[record.index - 1] = { ...newData[record.index - 1], saveLoading: true };
                                return newData;
                            });
                            const { data } = await axios({
                                method: 'PATCH',
                                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/pre-register/mobile`,
                                data: {
                                    _id: record._id,
                                    kind: record.kind,
                                    business_id: business_id,
                                    email: record.email,
                                    mobile_no: record.mobileNO
                                }
                            })
                            setData(prevData => {
                                const newData = [...prevData];
                                newData[record.index - 1] = { ...newData[record.index - 1], editTel: false, saveLoading: false };
                                return newData;
                            });
                            Swal.fire({
                                title: 'เปลี่ยนเบอร์โทรศัพท์สำเร็จ',
                                icon: 'success'
                            })
                        } catch (error) {
                            setData(defaultdata)
                            Swal.fire({
                                title: 'เปลี่ยนเบอร์โทรศัพท์ไม่สำเร็จ',
                                icon: 'error'
                            })
                        }
                    }
                    return (
                        <>
                            <TextField
                                value={record.mobileNO}
                                disabled={record.saveLoading}
                                label="เบอร์โทร"
                                variant="outlined"
                                size="small"
                                onChange={({ target }) => {
                                    if (/^[0-9\b]+$/.test(target.value) || target.value === '') {
                                        setData(prevData => {
                                            const newData = [...prevData];
                                            newData[record.index - 1] = { ...newData[record.index - 1], mobileNO: target.value.toString().slice(0, 10) };
                                            return newData;
                                        });
                                    }
                                }}
                                style={{
                                    width: '80%'
                                }}
                            />
                            <IconButton
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                    save()
                                }}
                                disabled={record.mobileNO.length < 10}
                                style={{
                                    width: '20%',
                                    top: '7px'
                                }}
                            >
                                <SaveIcon fontSize="inherit" />
                            </IconButton>
                        </>
                    )
                }
            }
        },
        {
            title: 'ที่อยู่',
            dataIndex: 'address',
            key: 'address',
            width: 250,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },

        {
            title: 'ตำบล',
            dataIndex: 'sub_district',
            key: 'sub_district',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'อำเภอ',
            dataIndex: 'district',
            key: 'district',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'จังหวัด',
            dataIndex: 'province',
            key: 'province',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'รหัสไปรษณีย์',
            dataIndex: 'zipcode',
            key: 'zipcode',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: (<div>Status</div>),
            dataIndex: 'active',
            key: 'active',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else if (_ === 'active') {
                    return (<Chip label="pre-regis" variant='outlined' color="success" />)
                }
                else {
                    return (<Chip label="revoked" variant='outlined' color="error" />)
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'การจัดการ',
            // dataIndex: 'status',
            width: 100,
            fixed: 'right',
            render: (_, record) => {
                const deleteRecord = async () => {
                    try {
                        const { data, status } = await axios({
                            method: 'DELETE',
                            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/pre-register/${record._id}?business_id=${business_id}`,
                        })
                        Swal.fire({
                            title: 'ลบข้อมูล Pre register สำเร็จแล้ว',
                            icon: 'success',
                        }).then(({ isConfirmed }) => {
                            setData(data.filter(e => e._id !== record._id).map((e, index) => {
                                return {
                                    ...e,
                                    index: index + 1,
                                }
                            }))
                            setDefaultData(defaultdata.filter(e => e._id !== record._id).map((e, index) => {
                                return {
                                    ...e,
                                    index: index + 1,
                                }
                            }))
                            setCountEmployees(countEmployees - 1)
                        })
                    } catch ({ response }) {

                    }
                }
                return (
                    <FadeIn>
                        <Stack direction="row" spacing={1}>
                            <>
                                <Popconfirm
                                    title="ต้องการลบข้อมูลนี้ใช่หรือไม่?"
                                    okText="ใช่"
                                    cancelText="ไม่ใช่"
                                    disabled={loading}
                                    onConfirm={() =>
                                        deleteRecord()
                                    }>
                                    <DeleteOutlinedIcon style={{ color: 'red' }} />
                                </Popconfirm>
                            </>
                        </Stack>
                    </FadeIn>
                )
            }
        },
    ]

    return (
        <FadeIn>
            {
                loading ?
                    <LoadingComponent />
                    :
                    <>
                        <Row>
                            <Col xl={3} lg={4} md={6} sm={12} xs={12}>
                                <Card
                                    style={{
                                        // width: 300,
                                        width: '100%',
                                        borderRadius: '16px',
                                        marginRight: '20px',
                                        marginBottom: '10px',
                                        cursor: 'pointer',
                                        backgroundImage: onlyNewData === false ? 'linear-gradient( transparent -10%, #3776E9 150%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        setOnlyNewData(false)
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <ListIcon style={{
                                                backgroundColor: '#3776E9',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#fff',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#3776E9',
                                                fontWeight: '700'
                                            }}>
                                                {countEmployees}
                                            </span>
                                            <br />
                                            สมาชิกทั้งหมด
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={12} xs={12}>
                                <Card
                                    style={{
                                        width: '100%',
                                        borderRadius: '16px',
                                        cursor: 'pointer',
                                        backgroundImage: onlyNewData === true ? 'linear-gradient( transparent -10%, #053075 160%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        setOnlyNewData(true)
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <PersonAddIcon style={{
                                                backgroundColor: '#EFF4FD',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#053075',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#3D5D85',
                                                fontWeight: '700'
                                            }}>
                                                {new_user_count}
                                            </span>
                                            <br />
                                            สมาชิกใหม่
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        <div style={{ marginBottom: '20px', marginTop: '20px' }}>
                            <div>
                                <h5>ค้นหา</h5>
                            </div>
                            <div xl={6} lg={10} md={6} sm={12} xs={12}>
                                <Input.Group compact>
                                    <Input
                                        value={searchtext}
                                        allowClear
                                        size="large"
                                        style={{
                                            width: 'calc(50% - 40px)',
                                        }}
                                        placeholder="ค้นหาด้วยชื่อ-นามสกุล, เลขบัตรประจำตัวประชาชน เบอร์โทร หรือรหัสพนักงาน"
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                        }}
                                        onPressEnter={() => {
                                            getData()
                                        }}
                                        maxLength={100}
                                    />
                                    <Button
                                        icon={<SearchOutlined />}
                                        size="large"
                                        style={{ borderRadius: '0px 4px 4px 0px' }}
                                        onClick={() => {
                                            getData()
                                        }}
                                    />
                                </Input.Group>
                            </div>
                        </div>
                        <Table
                            locale={customLocale}
                            columns={columns}
                            dataSource={data}
                            scroll={{
                                x: 1400,
                                y: 400,
                            }}
                            pagination={{
                                page: page,
                                defaultCurrent: page,
                                pageSize: pageSize,
                                onChange: (page, pageSize) => {
                                    setPage(page)
                                    setPageSize(pageSize)
                                },
                                total: resulttotal
                            }}
                        />
                    </>
            }
        </FadeIn >

    )
}

export default MophCaregiverTable